import type { RowData } from "@tanstack/react-table";
import { DensityRow } from "@design-system/SettingsPanel/DensityRow";
import type { DataGridDensity, DataGridInstance } from "../types";

/** The old view gear's labels: low density has the tallest rows. */
const DENSITY_OPTIONS: ReadonlyArray<{
    value: DataGridDensity;
    label: string;
}> = [
    { value: "relaxed", label: "Low" },
    { value: "default", label: "Medium" },
    { value: "compact", label: "High" },
];

/** The gear's Density row, shown when the table has `onDensityChange`. */
export const DensitySetting = <TData extends RowData>({
    instance,
}: Readonly<{ instance: DataGridInstance<TData> }>) => {
    if (!instance.canChangeDensity) {
        return null;
    }
    return (
        <DensityRow
            options={DENSITY_OPTIONS}
            value={instance.density}
            onChange={(density) =>
                instance.optionsRef.current.onDensityChange?.(density)
            }
        />
    );
};
